// api/productionType.js
import { apiRequest } from '@/api'

export const productionTypeApi = {
  getList() {
    return apiRequest('/api/production-types')
  },

  create(data) {
    return apiRequest('/api/production-types', {
      method: 'POST',
      body: data
    })
  },

  update(data) {
    return apiRequest('/api/production-types', {
      method: 'PUT',
      body: data
    })
  },

  delete(id) {
    return apiRequest('/api/production-types', {
      method: 'DELETE',
      body: { id }
    })
  }
}